import React from 'react'
import { Checkbox, Form } from 'semantic-ui-react'

interface ActionPermission {
  name: string
  label: string
  value: boolean
}

interface ActionPermissionFormProps {
  actions: ActionPermission[]
  handlePermissionChange: (paths: any[], value: any) => void
  isDisabled: boolean
}

export default function ActionPermissionForm({
  actions,
  handlePermissionChange,
  isDisabled,
}: ActionPermissionFormProps): JSX.Element | null {
  if (actions.length === 0) {
    return null
  } else {
    return (
      <Form.Group grouped>
        <label>Actions</label>
        {actions.map((action) => (
          <Form.Field key={action.name}>
            <Checkbox
              disabled={isDisabled}
              name={action.name}
              label={{
                children: <div>{action.label}</div>,
              }}
              checked={action.value}
              onChange={(_, { checked }) => {
                handlePermissionChange(['permissions', action.name], checked)
              }}
            />
          </Form.Field>
        ))}
      </Form.Group>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomRoleForm/components/ActionPermissionForm.tsx